import { render, staticRenderFns } from "./ProductThumbnail.vue?vue&type=template&id=5b478b90&scoped=true"
import script from "./ProductThumbnail.vue?vue&type=script&lang=js"
export * from "./ProductThumbnail.vue?vue&type=script&lang=js"
import style0 from "./ProductThumbnail.vue?vue&type=style&index=0&id=5b478b90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b478b90",
  null
  
)

export default component.exports